import BaseParagraph from "../../baseComponents/baseParagraph";
import Bug from "../../assets/bug.svg";
import BaseButton from "../../baseComponents/baseButton";

import LoginTemplate from "../loginStack/LoginTemplate.js";
import { useEffect, useRef } from "react";
import { actions as loginActions } from "../../store/slices/loginSlice.js";
import { useDispatch, useSelector } from "react-redux";
import WithContactInfo from "../../HOC/WithContactInfo";

const ErrorView = ({openContactInfo}) => {
  /////////////////////////////////////////////dispatcher
  const dispatch = useDispatch();

  /////////////////////////////////////////////redux states
  const dictionaryState = useSelector((state) => state.dictionaryState);

  /////////////////////////////////////////////variables derived from state
  const isDictionaryLoaded = dictionaryState.dictionaryLoaded;


  /////////////////////////////////////////////refs
  const mainButtonRef = useRef();

  /////////////////////////////////////////////methods

  const goBackToRoot = () => {
    dispatch(loginActions.logout());
    window.location.href = "/";
  };

  /////////////////////////////////////////////styles
  const styles = {
    errorContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },

    errorTitle: {
      fontSize: "40px",
      textAlign: "center",
      marginBottom: "0.5em",
    },
    errorMessage: {
      fontSize: "24px",
      textAlign: "center",
      marginBottom: "0.5em",
    },
    button: {
      paddingLeft: "1em",
      paddingRight: "1em",
      paddingTop: "0.5em",
      paddingBottom: "0.5em",
    },
  };

  /////////////////////////////////////////////effects

  /////////////////////////////////////////////render
  return (
    <LoginTemplate
      showPickers={false}
      icon={Bug}
      autoRelogin={false}
      focusElement={mainButtonRef}
    >
      <div style={styles.errorContainer}>
        <BaseParagraph
          bold
          style={styles.errorTitle}
          translate={isDictionaryLoaded}
        >
          {isDictionaryLoaded ? "unexpectedError" : "Neočekivana greška"}
        </BaseParagraph>
        <BaseParagraph
          style={styles.errorMessage}
          translate={isDictionaryLoaded}
        >
          {isDictionaryLoaded
            ? "unexpectedErrorMessage"
            : "Došlo je do neočekivane greške"}
        </BaseParagraph>
        <BaseButton
          style={styles.button}
          onClick={openContactInfo}
          translate={isDictionaryLoaded}
        >
          {isDictionaryLoaded ? "contactUs" : "Kontaktiraj nas"}
        </BaseButton>
        <BaseButton
          style={styles.button}
          onClick={goBackToRoot}
          innerRef={mainButtonRef}
          translate={isDictionaryLoaded}
        >
          {isDictionaryLoaded ? "homePage" : "Početna stranica"}
        </BaseButton>
      </div>
    </LoginTemplate>
  );
};

export default WithContactInfo(ErrorView);
